import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

interface SplashScreenProps {
  onFinished: () => void;
  duration?: number;
}

const SplashScreen: React.FC<SplashScreenProps> = ({
  onFinished,
  duration = 6000,
}) => {
  const navigate = useNavigate();
  
  useEffect(() => {
    const timer = setTimeout(() => {
      onFinished();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onFinished]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#1c1c1c]">
      <div className="flex flex-col items-center justify-center">
        <h1 
          className="text-[6rem] text-[#fff] cursor-pointer hover:text-[#40e0d0] transition-colors duration-200 uppercase tracking-wide font-extrabold"
          onClick={() => navigate('/')}
        >
          My<span className="text-[#40e0d0]">ǃ</span>hū
        </h1>
        
        <motion.div 
          className="text-foreground text-xl font-medium"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
        >
          <div className="flex items-center text-[#fff]">
            <span>Is loading</span>
            <motion.span
              initial={{ opacity: 0 }}
              animate={{ opacity: [0, 1, 0] }}
              transition={{ repeat: Infinity, duration: 1.5, repeatType: "loop" }}
            >
              .
            </motion.span>
            <motion.span
              initial={{ opacity: 0 }}
              animate={{ opacity: [0, 1, 0] }}
              transition={{ repeat: Infinity, duration: 1.5, repeatType: "loop", delay: 0.2 }}
            >
              .
            </motion.span>
            <motion.span
              initial={{ opacity: 0 }}
              animate={{ opacity: [0, 1, 0] }}
              transition={{ repeat: Infinity, duration: 1.5, repeatType: "loop", delay: 0.4 }}
            >
              .
            </motion.span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default SplashScreen;
